import { AccessRemoved } from './AccessRemoved/AccessRemoved';
import { CreateCompanyForm } from './CreateCompanyForm';
import { InvitationCard } from './InvitationCard';
import { OrganizationSelector } from './OrganizationSelector';
import { WelcomeMessage } from './WelcomeMessage';
import { UserOnboardingLayout } from './UserOnboardingLayout';

export const UserOnboarding = {
  AccessRemoved,
  CreateCompanyForm,
  InvitationCard,
  OrganizationSelector,
  WelcomeMessage,
  UserOnboardingLayout,
};
